__turbopack_context__.v({
  "clouds": "website-hero-landscape-module__aFe_Ba__clouds",
  "foreground": "website-hero-landscape-module__aFe_Ba__foreground",
  "plate": "website-hero-landscape-module__aFe_Ba__plate",
  "portal": "website-hero-landscape-module__aFe_Ba__portal",
  "shade": "website-hero-landscape-module__aFe_Ba__shade",
});
